<canvas #HistoryChart [attr.id]="'HistoryChart' + chartId">{{ chart }}</canvas>
<div>
    <div class="stats">{{ 'wap1_c_historic_fluctuation' | translate }}{{currencySymbol}} {{ wstd | number: '1.2-2' }} ({{ wstdp | number: '1.0-0' }}%)</div>
</div>
